<template>
  <div class="check_position">
    <gc-loading :is-show="loadingShow" />
    <h1 class="popup_title fw_bold">请选择职位</h1>
    <div class="popup_content">
      <p class="food_title fw_bold">{{ chinaInfo.name }}</p>
      <ul class="check_pos">
        <li v-for="item in chinaInfo.children" :key="item.id" :class="item.check == 1 ? 'checked' :''" @click="checkType(item)">{{ item.name }}</li>
        <li class="more_btn" @click="popupShowFn(chinaInfo.children[0])">
          <svg class="mr_10" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.01" y="0.5" width="12" height="12" fill="#D8D8D8" />
            <path d="M11 6.5V6.5V11.1667C11 11.3508 10.8508 11.5 10.6667 11.5H1.33333C1.14924 11.5 1 11.3508 1 11.1667V1.83333C1 1.64924 1.14924 1.5 1.33333 1.5H6V1.5" stroke="#999999" stroke-linecap="round" stroke-linejoin="round" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.09257 1.18633C9.21123 1.06667 9.37257 1 9.54057 1C9.70777 1.0008 9.86783 1.06794 9.98557 1.18667L10.6546 1.85567L11.3332 2.54433C11.4517 2.66279 11.5183 2.82347 11.5183 2.991C11.5183 3.15853 11.4517 3.31921 11.3332 3.43767L8.9349 5.83767L6.17057 8.60433C6.11895 8.65635 6.05082 8.68876 5.9779 8.696L4.0119 8.87267H3.98357C3.89467 8.87293 3.80977 8.83574 3.7497 8.77021C3.68962 8.70468 3.65993 8.61687 3.6679 8.52833L3.84457 6.561C3.85186 6.48809 3.88426 6.41999 3.93623 6.36833L6.69423 3.58633L9.09257 1.18633ZM9.98557 2.52533L9.54057 2.07667V2.077L7.36323 4.25567L4.7629 6.861L4.67157 7.843L5.6529 7.75167L8.25623 5.14933L10.4339 2.97067L9.98557 2.52533Z" fill="#999999" />
          </svg>
          其他</li>
      </ul>

      <div style="clear:both" /><van-divider />

      <p class="food_title fw_bold">{{ westInfo.name }}</p>
      <ul class="check_pos">
        <li v-for="item in westInfo.children" :key="item.id" :class="item.check == 1 ? 'checked' :''" @click="checkType(item)">{{ item.name }}</li>
        <li class="more_btn" @click="popupShowFn(westInfo.children[0])">
          <svg class="mr_10" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.01" y="0.5" width="12" height="12" fill="#D8D8D8" />
            <path d="M11 6.5V6.5V11.1667C11 11.3508 10.8508 11.5 10.6667 11.5H1.33333C1.14924 11.5 1 11.3508 1 11.1667V1.83333C1 1.64924 1.14924 1.5 1.33333 1.5H6V1.5" stroke="#999999" stroke-linecap="round" stroke-linejoin="round" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.09257 1.18633C9.21123 1.06667 9.37257 1 9.54057 1C9.70777 1.0008 9.86783 1.06794 9.98557 1.18667L10.6546 1.85567L11.3332 2.54433C11.4517 2.66279 11.5183 2.82347 11.5183 2.991C11.5183 3.15853 11.4517 3.31921 11.3332 3.43767L8.9349 5.83767L6.17057 8.60433C6.11895 8.65635 6.05082 8.68876 5.9779 8.696L4.0119 8.87267H3.98357C3.89467 8.87293 3.80977 8.83574 3.7497 8.77021C3.68962 8.70468 3.65993 8.61687 3.6679 8.52833L3.84457 6.561C3.85186 6.48809 3.88426 6.41999 3.93623 6.36833L6.69423 3.58633L9.09257 1.18633ZM9.98557 2.52533L9.54057 2.07667V2.077L7.36323 4.25567L4.7629 6.861L4.67157 7.843L5.6529 7.75167L8.25623 5.14933L10.4339 2.97067L9.98557 2.52533Z" fill="#999999" />
          </svg>
          其他
        </li>
      </ul>
    </div>
    <van-popup
      :show="popupShow"
      :closeable="false"
      position="bottom"
      :style="{ height: '40vh' }"
    >
      <div class="popup_content">
        <van-field
          v-model="message"
          autosize
          :border="true"
          type="text"
          clearable
          autofocus
          maxlength="10"
          placeholder="请输入自定义职位"
          show-word-limit
        />
        <div class="pd_16 mt_20">
          <van-button block type="info" @click="popupSave()">确定</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { ajaxHttp } from '@/api/api'
import { Toast, Popup, Field, Divider } from 'vant'

export default {
  name: 'CheckPosition',
  components: {
    vanPopup: Popup,
    vanField: Field,
    vanDivider: Divider
  },
  data() {
    return {
      loadingShow: true,
      popupShow: false,
      formData: {},
      pathInfo: {},
      message: '',
      isReadonly: true,
      chinaInfo: { children: [], name: '' },
      westInfo: { children: [], name: '' },
      popupItem: {}
    }
  },
  watch: {
    isShow: {
      handler(newVal, oldVal) {
        this.popupShow = newVal
      },
      immediate: true
    }
  },
  created() {
    const self = this
    this.$nextTick(() => {
      const { query } = self.$route
      self.pathInfo = query
      this.getPosData()
    })
  },
  methods: {
    getPosData() {
      const data = { ... this.pathInfo }
      const self = this
      this.loadingShow = true
      ajaxHttp.$get('/user/get_job_type_edit', data).then(res => {
        if (res.data.length > 0) {
          this.chinaInfo = res.data[0] || {}
          this.westInfo = res.data[1] || {}
        } else { Toast(res.message) }
        this.$nextTick(() => {
          self.loadingShow = false
        })
      })
    },
    popupShowFn($item) {
      // if (this.isReadonly) { return false }
      this.popupItem = $item
      this.popupShow = true
    },
    popupSave() {
      if (!this.message) { return false }
      const data = { job_type: this.popupItem.type, job_name: this.message, unit: this.pathInfo.unit }
      if (this.pathInfo.type === '3') {
        this.$router.push({ path: '/auth/status', query: { ...this.pathInfo, ...data }})
      } else {
        this.$router.push({ path: '/auth/opnAuth/form', query: { ...this.pathInfo, ...data }})
      }
    },
    onCancel() {
      this.$emit('onClosed', false)
    },
    checkType($item) {
      // this.$router.push({ path: '/auth/opnAuth/form', query: { job_type: $item.type, job_name: $item.name, unit: this.pathInfo.unit }})
      const data = { job_type: $item.type, job_name: $item.name, unit: this.pathInfo.unit }
      if (this.pathInfo.type === '3') {
        this.$router.push({ path: '/auth/status', query: { ...this.pathInfo, ...data }})
      } else {
        this.$router.push({ path: '/auth/opnAuth/form', query: { ...this.pathInfo, ...data }})
      }
    },
    onSelect(action, index) {
      this.formData.type = action.name
      console.log(action, index)
    }
  }
}
</script>

<style lang="scss">
  body{background: #fff;}
</style>

<style lang="scss" scoped>
@function rem($px){
	@return $px*(1/37.5)*1rem;
}
.check_position{
  height: 100vh;
  background: #fff;
}
.close_btn{border-top: none; color: #C99700;}
// .van-field{border: 1px solid #f5f5f5;}
  .popup_content{padding: rem(5) rem(16) rem(16); box-sizing: border-box;}
  .popup_title{
    margin: rem(12) 0 rem(12) rem(16);
    font-size: rem(22);line-height: rem(27); color: #333;
  }
  .food_title{
    margin: rem(10) 0;
    font-size: rem(16);line-height: rem(17); color: #333; text-align: left;
  }
  .check_pos{
    display: block;
    width: 100%;
    overflow: hidden;
    li{
      float: left; font-size: rem(14); line-height: rem(27); margin: rem(7);
      padding: rem(2) rem(13); background: #f5f5f5; color: #666;
      border-radius: rem(2);
      border: 1px dashed #f5f5f5;
    }
    .more_btn{display: flex; align-items: center; background: transparent; border: 1px dashed #e5e5e5;}
    .checked{color: #C99700 ; background: #F9F4E5; border: 1px dashed #F9F4E5; font-weight: bold;}
  }
</style>
